import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from './Reveal';
import { projects } from '../assets/work/galleryData';
import { trackEvent } from '../analytics';

const services = [
  { name: 'Renovations', detail: 'Internal alterations, cladding, doors and finishing carpentry.', to: '/renovations-hobart', image: 'cladding-timber-ceiling' },
  { name: 'Repair work', detail: 'Timber repairs, sticking doors, damaged decking and general maintenance.', to: '/handyman-hobart', image: 'nans-deck' },
  { name: 'New build carpentry', detail: 'Timber framing, lock-up and fit-out for new homes and extensions.', to: '/framing-carpenter-hobart', image: 'frame-caulfield' },
  { name: 'Kitchens & bathrooms', detail: 'Cabinet installation, timber fit-out and renovation carpentry.', to: '/renovations-hobart', image: 'cladding-timber-ceiling' },
  { name: 'Decking & fencing', detail: 'Timber decks, stairs, pergolas, fences and gates.', to: '/decks-and-fences-hobart', image: 'deck-primrose' },
  { name: 'Joinery & built-ins', detail: 'Wardrobes, shelving, storage and custom timber work.', to: '/custom-interiors-hobart', image: 'cladding-timber-ceiling' },
];

export default function AtelierServices() {
  const [active, setActive] = useState(0);
  const [displayed, setDisplayed] = useState(0);
  const [loaded, setLoaded] = useState({});
  useEffect(() => { if (loaded[active]) setDisplayed(active); }, [active, loaded]);
  return (
    <section className="atelier-services" id="services" data-testid="services-section" aria-labelledby="atelier-services-title">
      <div className="container">
        <Reveal className="atelier-section-heading">
          <p className="atelier-kicker">01 / Carpentry services</p>
          <h2 id="atelier-services-title">Renovations. Repairs.<br /><em>New builds &amp; fit-outs.</em></h2>
        </Reveal>
        <div className="atelier-services-grid">
          <Reveal className="atelier-service-visual">
            <figure>
              <div className="atelier-service-photo-stack">
                {services.map((service, index) => {
                  const photo = projects.find(p => p.id === service.image);
                  return <picture key={service.name} className={displayed === index ? 'is-visible' : ''} aria-hidden={displayed !== index}>
                    <source type="image/webp" srcSet={`${photo.thumb.webp640} 640w, ${photo.thumb.webp960} 960w`} sizes="(max-width: 767px) 100vw, 45vw" />
                    <img src={photo.thumb.jpg} alt={displayed === index ? photo.alt : ''} width="960" height="720" loading="lazy" decoding="async"
                      onLoad={() => setLoaded(previous => previous[index] ? previous : { ...previous, [index]: true })} />
                  </picture>;
                })}
              </div>
              <figcaption><span>Work &amp; inspiration</span><span>{String(displayed + 1).padStart(2, '0')} / {String(services.length).padStart(2, '0')}</span></figcaption>
            </figure>
          </Reveal>
          <div className="atelier-service-index">
            {services.map((service, index) => (
              <Reveal key={service.name} delay={index * 70}>
                <Link to={service.to} className={`atelier-service-row${index === active ? ' is-active' : ''}`} onMouseEnter={() => setActive(index)} onFocus={() => setActive(index)}
                  onClick={() => trackEvent('service_card_click', { target: service.to })}>
                  <span className="atelier-service-num">0{index + 1}</span>
                  <span><h3>{service.name}</h3><p>{service.detail}</p></span>
                  <ArrowUpRight size={24} strokeWidth={1.4} aria-hidden="true" />
                </Link>
              </Reveal>
            ))}
            <p className="atelier-service-note">Carpentry across Hobart and surrounding suburbs.<br /><a href="#contact">Request a quote <ArrowUpRight size={15} aria-hidden="true" /></a></p>
          </div>
        </div>
      </div>
    </section>
  );
}
